/* eslint-disable react/jsx-no-bind */
import React from 'react';
import { ReactComponent as GroupTypeIcon } from '../../../assets/icons/groupType1.svg';
import './manage-group-types.less';
import { icons } from '../create-group-type/create-group-type.page';
import { iconNames } from '../../../store/modules/facility/i-facility';
import SecondaryButton from '../../lib/secondary-button';
import checkPermission from '../../../utils/permissions/permissions';

interface IManageGroupTypeCard {
  icon?: iconNames | null,
  title: string,
  onPress: (id:number) => void
  id:number,
}

const ManageGroupTypeCard = ({
  icon,
  title,
  onPress,
  id,
} : IManageGroupTypeCard) : JSX.Element => {
  const Icon = icon ? icons[icon].icon : GroupTypeIcon;
  const hasNotWritePermission = !checkPermission('organization', 'write');
  return (
    <div className="groupType-card">
      <div className="groupType-card__img-container">
        <Icon className="groupType-card__img" />
      </div>
      <h3 className="groupType-card__title">{title}</h3>
      <SecondaryButton onClick={() => onPress(id)} className="groupType-card__btn ant-btn--small">{!hasNotWritePermission ? 'Edit' : 'View'}</SecondaryButton>
    </div>
  );
};

export default ManageGroupTypeCard;
